import '../styles/theme.scss'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { vuetifyOpts } from '@/utilities/vuetify-config'

Vue.use(Vuetify)

export default new Vuetify(vuetifyOpts)
